<template>
    <button
        ref="helpTextHover"
        class="btn btn-transparent p-1 ml-2 nowrap"
        data-trigger="hover focus"
        :data-content="popoverContent"
        data-placement="top"
        @click="resolve()"
        :disabled="disabled"
    >
        <span
            class="icon"
            :class="{
                'icon-glyphicons-basic-check text-primary': !resolved,
                'icon-glyphicons-basic-circle-empty-check text-success': resolved
            }"></span>
    </button>
</template>

<script>
export default {
    name: "ResolveButton",
    props: {
        resolved: {
            type: Boolean,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    methods: {
        resolve() {
            this.$emit('click')
            $(this.$refs.helpTextHover).popover('hide')
        }
    },
    computed: {
        popoverContent() {
            return this.resolved ? "Click to remove resolved flag" : "Mark as resolved"
        }
    },
    mounted() {
        $(this.$refs.helpTextHover).popover({
            boundary: 'window'
        })
    }
}
</script>